import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { TinyMCEEditorComponent } from './editor.component';
import { FormsModule } from '@angular/forms';
import { FileUploadPickerModule } from '../file-upload-picker/file-upload-picker.module';
import { EditorModule } from '@tinymce/tinymce-angular';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    SvgIconModule,
    CommonModule,
    VirtualScrollerModule,
    FormsModule,
    FileUploadPickerModule,
    EditorModule
  ],
  declarations: [
    TinyMCEEditorComponent
  ],
  exports: [
    TinyMCEEditorComponent
  ]
})
export class TinyMCEEditorModule {}
